import React, { useEffect, useRef } from 'react'
import ApiService from '../../../services/ApiService'
import { companyComponentsProps } from '../types'
import { InputData } from '../style'

const InsertCEPComponent: React.FC<companyComponentsProps> = ({ company, setCompany, setAutoAddress, autoAddress }) => {
  const lastSearchedCep = useRef<string>('')

  const triggerCepLookup = (rawCep: string) => {
    const digitsOnlyCep = rawCep.replace(/\D/g, '')

    console.log(`🗺️ [CEP] tentará buscar para CEP: "${rawCep}" (digits: "${digitsOnlyCep}") | lastSearched: "${lastSearchedCep.current}"`)

    if (digitsOnlyCep.length !== 8) {
      lastSearchedCep.current = ''
      console.log('🗺️ [CEP] CEP incompleto, não busca.')
      return
    }

    if (digitsOnlyCep === lastSearchedCep.current) {
      console.log('🗺️ [CEP] CEP já buscado, ignorando.')
      return
    }

    lastSearchedCep.current = digitsOnlyCep

    ApiService.companies.getCepInfo(digitsOnlyCep)
      .then((response: any) => {
        const data = response.data || {};
        const street = data.logradouro || (typeof data.street === 'string' ? data.street : '') || '';
        const neighborhoodRaw = data.bairro || data.neighborhood?.name || (typeof data.neighborhood === 'string' ? data.neighborhood : '') || '';
        const neighborhoodName = typeof neighborhoodRaw === 'string' ? neighborhoodRaw : '';
        const cityRaw = data.localidade || data.city?.name || (typeof data.city === 'string' ? data.city : '') || '';
        const cityName = typeof cityRaw === 'string' ? cityRaw : '';
        const stateRaw = data.uf || data.state?.name || (typeof data.state === 'string' ? data.state : '') || '';
        const stateName = typeof stateRaw === 'string' ? stateRaw : '';
        const returnedCep = data.cep || '';

        console.log('🗺️ [CEP] callback result:', data)

        if (street || neighborhoodName || cityName || stateName) {
          if (setCompany) {
            setCompany((prev: any) => {
              console.log('🗺️ [CEP] atualizando campos com dados do CEP / prev:', prev)

              const updated: any = { ...prev }
              const autoAddressUpdates: { state?: boolean; city?: boolean; neighborhood?: boolean; street?: boolean } = {
                state: false,
                city: false,
                neighborhood: false,
                street: false,
              }

              updated.street = ''
              updated.neighborhood = { id: 0, name: '' }
              updated.city = { id: 0, name: '' }
              updated.state = { id: 0, name: '' }
              updated.number = ''
              updated.complement = ''

              if (street) {
                updated.street = street
                autoAddressUpdates.street = true
              }
              if (neighborhoodName) {
                updated.neighborhood = { id: data.neighborhood?.id || 0, name: neighborhoodName }
                autoAddressUpdates.neighborhood = true
              }
              if (cityName) {
                updated.city = { id: data.city?.id || 0, name: cityName }
                autoAddressUpdates.city = true
              }
              if (stateName) {
                updated.state = { id: data.state?.id || 0, name: stateName }
                autoAddressUpdates.state = true
              }

              if (returnedCep) {
                updated.cep = returnedCep
              } else if (!updated.cep) {
                updated.cep = `${digitsOnlyCep.slice(0, 5)}-${digitsOnlyCep.slice(5)}`
              }

              if (setAutoAddress && (autoAddressUpdates.state || autoAddressUpdates.city || autoAddressUpdates.neighborhood || autoAddressUpdates.street)) {
                setAutoAddress(prev => ({ ...prev, ...autoAddressUpdates }))
              }

              console.log('🗺️ [CEP] updated company state after lookup:', updated)
              return updated
            })
          }
        } else {
          console.log('🗺️ [CEP] resposta com dados insuficientes, não atualiza endereço.')
        }
      })
      .catch((error: any) => {
        console.log('🗺️ [CEP] erro ao consultar CEP:', error)
      })
  }

  const maskCEP = (value: any) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{5})(\d)/, '$1-$2')
      .slice(0, 9)
  }

  useEffect(() => {
    const digitsOnlyCep = (company?.cep || '').replace(/\D/g, '')
    if (digitsOnlyCep.length < 8 && setAutoAddress) {
      setAutoAddress({ state: false, city: false, neighborhood: false, street: false })
      lastSearchedCep.current = ''
    }
  }, [company?.cep, setAutoAddress])

  return (
    <InputData
      placeholder={'00000-000'}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        if (setCompany) {
          setCompany((prev: any) => ({ ...prev, cep: value }))
        }
        triggerCepLookup(value)
      }}
      value={maskCEP(company?.cep || '')}
    />
  )
}

export default InsertCEPComponent